// extracted by mini-css-extract-plugin
export default {"option":"option--zHQe2","checkBox":"checkBox--eGRFB","small":"small--qFYOR","defaultInput":"defaultInput--LxxWT","isActiveRound":"isActiveRound--FLRhS"};